import { render, staticRenderFns } from "./OrderPrepDateControls.vue?vue&type=template&id=c10d0578&"
import script from "./OrderPrepDateControls.vue?vue&type=script&lang=js&"
export * from "./OrderPrepDateControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VMenu,VTextField})
